// extracted by css-extract-rspack-plugin
export default {"menuItems":"_e41b35c2","menuItem":"_be528a31","menuIcon":"_de6e046f","link":"_cf184e37"};